export default __webpack_public_path__ + "static/media/C0001.0be0ef1a.png";